<template>
  <div data-aos="zoom-in" data-aos-offset="0" data-aos-mirror="true">
    <v-container>
      <v-row class="item">
        <v-col
          cols="12"
          md="3"
          class="img"
          :style="{ backgroundImage: 'url(' + SYS.setImg(item) + ')' }"
        ></v-col>
        <v-col
          v-resize="onResize"
          cols="12"
          md="9"
          ref="listItemContent"
          style="height:209px"
        >
          <div
            class="d-flex justify-start align-center"
            style="position:relative;"
          >
            <div
              class="ma-1 categoryItem"
              style="width:150px"
              :style="{
                backgroundColor: SYS.setCategoryBgColor(item.subcategory)
              }"
            >
              {{ SYS.setCategory(item.subcategory) }}
            </div>
            <div class="ct-text-subtitle2 ct-text-ellipsis">
              {{ item.title }}
            </div>
            <v-spacer />
            <!-- 20240911 add Important -->
            <div v-if="item.important" class="importantChip">
              精選
            </div>
            <!-- <div class="grey--text" style="position:absolute;right:0px">
            公告日期：{{ setDateString(item.onlineDate) }}
          </div> -->
          </div>
          <v-divider />
          <div class="ct-font-JH">
            <div class="d-flex justify-start align-center margin">
              <div class="grey--text">
                公告日期：{{ TOOL.setDateString(item.onlineDate) }}
              </div>
            </div>
            <div class="d-flex justify-start align-center">
              <div class="ct-text-wrap">
                {{ setContent }}
              </div>
            </div>
            <div
              v-if="
                item.file != null &&
                  !(typeof item.file == 'undefined') &&
                  download
              "
              class="d-flex justify-start align-center margin"
            >
              <FileItem :item="item.file" />
            </div>
            <!-- 20240704 Ben說隱藏 -->
            <!-- <div
              v-if="
                typeof item.answerStr != 'undefined' &&
                  (item.answerStr != '' || item.answerStr != null)
              "
              class="ct-text-bolder ct-text-ellipsis"
              style="position:absolute;bottom:12px;width:60%"
            >
              專家答覆：{{ item.answerStr }}
            </div> -->
            <slot />
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import FileItem from "@/components/ui/detailComponent/FileItem.vue";
export default {
  components: {
    FileItem
  },
  props: {
    item: {
      type: Object,
      default() {
        return {
          sno: 0,
          category: 1,
          title: "標題",
          onlineDate: Date.now(),
          content: "內容"
        };
      }
    },
    download: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      c_height: 209,
      c_width: 600,
      c_file_height: 164
    };
  },
  mounted() {
    this.onResize();
  },
  computed: {
    setContent() {
      let charNum = 250;
      let file_height = this.fileHeight();
      let command_height = this.commandHeight();
      let volumn =
        (this.c_height - file_height - command_height) * this.c_width;
      let fontSize = 16;
      charNum = volumn / (Math.pow(fontSize, 2) * 4);
      let content = this.TOOL.setNoHTMLTag(
        this.TOOL.getContentStr(this.item.content)
      );
      if (content.length > charNum) {
        return content.substring(0, charNum - 3) + "...";
        //return this.item.content.substring(0, charNum - 3) + "...";
      } else {
        return content;
      }
    }
  },
  methods: {
    fileHeight() {
      let height = 0;
      if (
        this.item.file != null &&
        !(typeof this.item.file == "undefined") &&
        this.download
      ) {
        height = this.c_file_height;
      }
      return height;
    },
    commandHeight() {
      let height = 0;
      if (
        typeof this.item.answerStr != "undefined" &&
        (this.item.answerStr != "" || this.item.answerStr != null)
      ) {
        height = this.c_file_height;
      }
      return height;
    },
    onResize() {
      let el = null;
      el = this.$refs.listItemContent;
      if (el != null) {
        this.c_height = el.clientHeight;
        this.c_width = el.clientWidth;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.item {
  cursor: pointer;
  position: relative;
  min-height: 209px;
  background-color: white;
  border-radius: 5px;
  box-shadow: 0px 0px 10px rgba(201, 201, 201, 0.25);
  .img {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: 50% 50%;
    background-image: url("~@/assets/images/announce/bg_title.png");

    @media (max-width: 767px) {
      height: 125px;
    }
  }
}
.margin {
  margin-top: 4px;
  margin-bottom: 4px;
}
</style>
